import { appendReloadTimestamp, countReloadTimestamps } from './storageSync';
import { renderHaltScreen } from './bootstrapGuard';

const HALT_WINDOW_MS = 20_000;
const HALT_COUNT = 8;

const STRIPE_BYPASS_HOSTS = ['checkout.stripe.com', 'billing.stripe.com'];

function isStripeUrl(url: string): boolean {
  try {
    return STRIPE_BYPASS_HOSTS.some(host => url.includes(host));
  } catch {
    return false;
  }
}

// location.reload() replacement — appends to reload ledger and checks breaker
export function guardedReload(): void {
  try {
    const now = Date.now();
    appendReloadTimestamp(now, HALT_WINDOW_MS);
    const count = countReloadTimestamps(HALT_WINDOW_MS, now);
    if (count > HALT_COUNT) {
      renderHaltScreen();
      return;
    }
    window.location.reload();
  } catch {
    window.location.reload(); // A4: fail-open
  }
}

// location.href replacement — Stripe external URLs bypass the ledger entirely
export function guardedNavigate(to: string): void {
  try {
    // Stripe payment redirect: bypass breaker, no ledger append
    if (isStripeUrl(to)) {
      window.location.href = to;
      return;
    }
    window.location.href = to;
  } catch {
    window.location.href = to; // A4: fail-open
  }
}
